import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'lc-form-loading-indicator',
    standalone: true,
    imports: [CommonModule],
    template: `
        @if (loading) {
            <div class="loading-indicator">
                <div class="spinner"></div>
                <span class="loading-text">{{ message || 'Processando...' }}</span>
            </div>
        }
    `,
    styles: [
        `
            .loading-indicator {
                @apply flex justify-center items-center py-4;
            }

            .spinner {
                @apply animate-spin rounded-full h-6 w-6 border-b-2 border-primary;
            }

            .loading-text {
                @apply ml-2 text-sm text-gray-600 dark:text-gray-400;
            }
        `,
    ],
})
export class FormLoadingIndicatorComponent {
    @Input() loading: boolean = false;
    @Input() message?: string;
}
